
.header {
  background: var(--color-surface-primary);
  border-bottom: 1px solid var(--color-border);
  width: 100%;
}

.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 72px;
  padding: 0 map.get($spacing-scale, 'xl');
  overflow: hidden;
}

.container {
  display: flex;
  align-items: center;
  gap: map.get($spacing-scale, 'sm');
  width: 100%;
  max-width: 1200px;
}

.logo {
  display: flex;
  flex: 1;
  align-items: center;
}

.logoImage {
  height: 26px;
  width: 131px;
  object-fit: contain;
}

.actions {
  display: flex;
  align-items: center;
  gap: map.get($spacing-scale, 'sm');
}

.tabsContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  padding: 0 map.get($spacing-scale, 'xl');
  overflow: hidden;
  width: 100%;
}

.tabs {
  display: flex;
  align-items: flex-start;
  gap: map.get($spacing-scale, 'lg');
  max-width: 1200px;
  width: 100%;
  overflow: hidden;
  border-bottom: none !important;
  background: transparent !important;
}
